import React, { useContext } from "react";
import { Badge as ChakraBadge, Text } from "@chakra-ui/react";
import { BadgeGroupItemContext } from "./badge-group-item-context";
export function LabelBadge({ label, value, ...props }) {
    const { isHidden } = useContext(BadgeGroupItemContext);
    return (React.createElement(ChakraBadge, { variant: "label", "aria-hidden": isHidden ? "true" : undefined, title: `${label}: ${value}`, ...props },
        label,
        ":",
        " ",
        React.createElement(Text, { as: "span", fontSize: "inherit", fontWeight: "medium" }, value)));
}
